// extracted by mini-css-extract-plugin
module.exports = {"barChart":"BarChart_barChart__lWK2X"};